import api from '@/plugins/api';

export default class {
  items = [];
  old = [];
  quota = 0;

  timer;

  constructor(parent) {
    this.parent = parent;
  }

  get total() {
    return this.items.reduce((a, i) => a + i.sum, 0);
  }

  get totalQuota() {
    return this.items.reduce((a, i) => a + i.sumTourist, 0);
  }

  get adult() {
    return this.items.reduce((a, i) => a + i.adult * i.count, 0);
  }

  get child() {
    return this.items.reduce((a, i) => a + i.child * i.count, 0);
  }

  get data() {
    return {
      TourId: this.parent.id,
      Tariffs: this.items
        .filter(i => i.count)
        .map(i => ({
          TariffId: i.value,
          SelectedCount: i.count,
        })),
    };
  }
  get tariffIds() {
    const selectedIds = [];
    this.items
      .filter(i => i.count)
      .map(function (i) {
        selectedIds.push(...Array.from({length: i.count}, () => i.value))
      });
    return selectedIds.join(',');
  }

  set({tariffs, activeQuota} = {}) {
    this.quota = activeQuota;
    this.items = tariffs.map(i => ({
      ...i.tariff,
      count: i.selectedCount,
      price: i.brutto,
      adult: i.adultCount,
      child: i.childCount,
      tourist: i.adultCount + i.childCount,
      get sumTourist() {
        return this.tourist * this.count;
      },
      get sum() {
        return this.price * this.count;
      },
    }));
    this.old = this.items.map(i => ({
      value: i.value,
      count: i.count,
    }));
  }


  get priceTour() {
    return this.items.reduce((a, i) => a + i.price * i.count, 0);
  }

  add(value) {
    console.log('client item tariff add', value);
    const index = this.items.findIndex(i => i.value === value.value);
    const item = this.items[index];
    const count = item.count + 1;
    this.items[index].count = count;
    this.submit();
  }

  remove(value) {
    const index = this.items.findIndex(i => i.value === value.value);
    const item = this.items[index];
    let count = item.count - 1;
    if (count < 0) count = 0;
    this.items[index].count = count;
    this.submit();
  }

  submit() {
    const a = this.data.TourId.split('_');
    const tourId = `${a[0]}_${this.tariffIds}_${a[2]}`;
    const data = {
      price: this.priceTour,
      tour: {
        value: tourId,
      },
      tariffs: this.items
    }
    this.parent.setTariff(data);
  }
}
